<template>
  <div class="list">
    <div class="list__left">
      <slot name="left"></slot>
    </div>
    <div class="list__right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
};
</script>

<style scoped lang="scss">
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    font-size: var(--font-p);
    &__left {
      font-weight: 500;
    }

    &__right {
      color: var(--color-link-inactive);
    }
  }
</style>
